<template>
  <div>
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item" href="/#">
          <img src="/logo.png" width="72" height="28" />
        </a>
        <div
          class="navbar-burger burger"
          :class="{'is-active': burgerActive}"
          @click="burgerActive = !burgerActive"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{'is-active': burgerActive}">
        <div class="navbar-start">
          <router-link to="/" class="navbar-item">
            <span class="icon">
              <i class="fas fa-home"></i>
            </span>
            <span class="is-hidden-desktop-only">Home</span>
          </router-link>
          <router-link :to="{path: '/filmBoard', query: {links: 0}}" class="navbar-item">
            <span class="icon">
              <i class="fas fa-film"></i>
            </span>
            <span class="is-hidden-desktop-only">Film</span>
          </router-link>
          <router-link to="/actorBoard" class="navbar-item">
            <span class="icon">
              <i class="fas fa-star"></i>
            </span>
            <span class="is-hidden-desktop-only">Actor</span>
          </router-link>
        </div>
      </div>
    </nav>
    <div class="container is-fullhd">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <footer class="hero">
      <div class="has-text-centered hero-body">
        <p>
          <strong>My Services</strong>
        </p>
      </div>
    </footer>
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from "./components/BackToTop";

export default {
  name: "app",
  components: { BackToTop },
  data: function() {
    return {
      burgerActive: false
    };
  },
  mounted: function() {},
  methods: {}
};
</script>
<style scoped>
footer.footer {
  margin-top: 3rem;
  border-top: 1px #e4d4d4 solid;
}
</style>
